
import { RoleManageModel } from '../../_models/system-management/role.manage/role.manage.model';
import { AuthModel } from './auth.model';

export class UserModel extends AuthModel {
  id: string;
  userName: string;
  password: string;
  email: string;
  pic: string;
  roleId: string;
  roles: RoleManageModel[];
  isAdmin: boolean;
  fullName: string;
  defaultPassword: boolean;
  setUser(user: any) {
    this.id = user.id;
    this.userName = user.username || '';
    this.password = user.password || '';
    this.email = user.email || '';
    this.pic = user.pic || './assets/media/users/default.jpg';
    this.roles = user.roles || [];
  }

  setUserAuth(userName: string, email: string) {
    this.userName = userName;
    this.email = email;
  }
}
export class UserMenu {
  id: string
  userId: string
  userName: string
  email: string
  fullName: string
}
export class UserMenuFilterModel {
  pageIndex: number
  pageSize: number
  sortField: string
  sortOrder: number
  isPaging: boolean
  keyword: string
  userName: string
  chartId: string
}